export interface HTMLProps {
    className?: string;
    html?: string;
    children?: string;
    as?: React.ElementType;
}

const HTML: React.FC<HTMLProps> = ({ className, children, html, as: Component = 'div' }) => {
    const htmlStr = children || html;

    if (!htmlStr) {
        return null;
    }

    return <Component className={className} dangerouslySetInnerHTML={{ __html: htmlStr }}></Component>;
};

export default HTML;
